const types = {
	//Get Template name
	GET_MANAGE_PARTICIPANTS_START: "GET_MANAGE_PARTICIPANTS_START",
	GET_MANAGE_PARTICIPANTS_SUCCESS: "GET_MANAGE_PARTICIPANTS_SUCCESS",
	GET_MANAGE_PARTICIPANTS_ERROR: "GET_MANAGE_PARTICIPANTS_ERROR",
	GET_MANAGE_PARTICIPANTS_RESET: "GET_MANAGE_PARTICIPANTS_RESET",

	//Create Template name
	CREATE_MANAGE_PARTICIPANTS_START: "CREATE_MANAGE_PARTICIPANTS_START",
	CREATE_MANAGE_PARTICIPANTS_SUCCESS: "CREATE_MANAGE_PARTICIPANTS_SUCCESS",
	CREATE_MANAGE_PARTICIPANTS_ERROR: "CREATE_MANAGE_PARTICIPANTS_ERROR",
	CREATE_MANAGE_PARTICIPANTS_RESET: "CREATE_MANAGE_PARTICIPANTS_RESET",

	//delete Template name
	DELETE_MANAGE_PARTICIPANTS_START: "DELETE_MANAGE_PARTICIPANTS_START",
	DELETE_MANAGE_PARTICIPANTS_SUCCESS: "DELETE_MANAGE_PARTICIPANTS_SUCCESS",
	DELETE_MANAGE_PARTICIPANTS_ERROR: "DELETE_MANAGE_PARTICIPANTS_ERROR",
	DELETE_MANAGE_PARTICIPANTS_RESET: "DELETE_MANAGE_PARTICIPANTS_RESET",

	//update Template name
	UPDATE_MANAGE_PARTICIPANTS_START: "UPDATE_MANAGE_PARTICIPANTS_START",
	UPDATE_MANAGE_PARTICIPANTS_SUCCESS: "UPDATE_MANAGE_PARTICIPANTS_SUCCESS",
	UPDATE_MANAGE_PARTICIPANTS_ERROR: "UPDATE_MANAGE_PARTICIPANTS_ERROR",
	UPDATE_MANAGE_PARTICIPANTS_RESET: "UPDATE_MANAGE_PARTICIPANTS_RESET",

	//single item  name
	SINGLE_MANAGE_PARTICIPANTS_START: "SINGLE_MANAGE_PARTICIPANTS_START",
	SINGLE_MANAGE_PARTICIPANTS_SUCCESS: "SINGLE_MANAGE_PARTICIPANTS_SUCCESS",
	SINGLE_MANAGE_PARTICIPANTS_ERROR: "SINGLE_MANAGE_PARTICIPANTS_ERROR",
	SINGLE_MANAGE_PARTICIPANTS_RESET: "SINGLE_MANAGE_PARTICIPANTS_RESET",
};

export default types;
